

import { Card, Tabs, Table, Row, Col, Tag, Form, Input, Button, Spin, Menu, Upload, Badge, Modal, Skeleton, Select, Image, Space, List, Divider, InputNumber, DatePicker, Carousel, Dropdown, Checkbox, Typography, Tooltip, Switch } from "antd";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
// import Clock from 'react-live-clock';
import { formatCurrency } from '../common/Format'
import {
    PhoneOutlined, SettingOutlined, DeleteOutlined, MailOutlined, FormOutlined, CloseSquareOutlined, UpOutlined, CloseCircleOutlined, LeftSquareOutlined,
    PlusOutlined, GlobalOutlined,
    FileExcelOutlined, CalendarOutlined, RedoOutlined
} from "@ant-design/icons";
import swal from "sweetalert";

import 'moment/locale/vi';
import { QRCodeSVG } from 'qrcode.react';
import ButtonGroup from "antd/lib/button/button-group";

import axiosClient from '../../api/axios'
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver'; // <<< DÒNG NÀY ĐÃ CÓ
import { countryList } from "../common/Country/country";
import LinkUpload from "../../api/LinkUpload";
import limitString from "../common/LimitString/litmitstring";
import { changeUpload, updateFileListFromUrls, uploadImage, beforeUpload, getFilePreview } from '../common/Upload/upload.js'
import NoImage from '../Images/No-Avatar.jpg'

const { TabPane } = Tabs;
const { Option } = Select;
const { RangePicker } = DatePicker;
const { Text } = Typography;
const Members = () => {
    const fileInputRef = useRef(null);
    const location = useLocation();
    const [formFilterCustomer] = Form.useForm()
    const [progress, setProgress] = useState(0);
    const [fileList, setFileList] = useState([]);
    const database = localStorage.getItem('DatabaseName');
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('Role');
    const IDAccount = Number(localStorage.getItem('ID'));
    const [dataHeader, setDataHeader] = useState([])
    const [dataFilterMember, setDataFilterMember] = useState({
        "FullName": "",
        "Phone": "",
        "Email": "",
        "Code": "",
        "Organization": "",
        "FromDate_JoinDate": "",
        "ToDate_JoinDate": ""
    })
    const header = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    const [formMembers] = Form.useForm();
    const [dataPermission, setDataPermission] = useState([])

    const [statusMembers, setStatusMembers] = useState(false);
    const [openModalMembers, setOpenModalMembers] = useState(false)

    const handleOkMembers = () => {
        setTimeout(() => {
            setOpenModalMembers(false);
        }, 3000);
    }

    const handleCancelMembers = () => {
        setOpenModalMembers(false);
        formMembers.resetFields()
    }

    const [dataMembersAll, setDataMembersAll] = useState([])
    const LoadDataMembers = async (values) => {
        try {
            const [resAll] = await Promise.all([

                axiosClient.post('/Members/GetMembersAll', {}, { headers: header })
            ]);
            const customHeadings = resAll.data.sort((a, b) => new Date(a.JoinDate) - new Date(b.JoinDate)).map(item => ({
                "Tên khách hàng": item.FullName,
                "Số điện thoại": item.Phone,
                "Email": item.Email,
                "Địa chỉ": item.Address,
                "Ngày sinh": item.BirthDay,
                "Mã thẻ": item.Code,
                "Tổ chức": item.Organization,
                "Thời gian tham gia": moment(item.JoinDate).format('DD-MM-YYYY HH:mm'),
                "Đường dẫn": item.Link,
                "Giới thiệu": item.Introduction,
                "Hình ảnh": item.Image
            }))
            setDataHeader(customHeadings)
            setDataMembersAll(resAll.data.sort((a, b) => new Date(a.JoinDate) - new Date(b.JoinDate)))

        } catch (error) {
            console.error("Lỗi khi tải dữ liệu thành viên:", error?.response?.data || error);
        }
    }
    const LoadDataPermission = () => {
        axiosClient.post('/Permissions/GetApiPermissionAll', '', { headers: header }).then(res => {
            setDataPermission(res.data)
        })
    }
    // TỔ CHỨC HÀNH NGHỀ
    const [formOrganizations] = Form.useForm();
    const [openModalOrganizations, setOpenModalOrganizations] = useState(false)
    const [statusOrganizations, setStatusOrganizations] = useState(false)
    const [formFilterOrganizations] = Form.useForm()
    const [dataFilterOrganizations, setDataFilterOrganizations] = useState({
        "Name": "",
        "Phone": "",
        "Email": "",
    });
    const [dataOrganizationsAll, setDataOrganizationsAll] = useState([])
    const [dataHeaderOrganizations, setDataHeaderOrganizations] = useState([]); // <-- STATE MỚI

    // <<< HÀM ĐƯỢC CẬP NHẬT: Chỉ lấy tất cả dữ liệu, việc lọc sẽ ở client
    const LoadDataOrganizations = () => {
        axiosClient.post(`/Organizations/GetOrganizationsAll`, {}, { headers: header })
            .then(resAll => {
                const allOrgs = resAll.data || [];
                setDataOrganizationsAll(allOrgs);

                // Chuẩn bị dữ liệu cho việc xuất Excel
                const customHeadingsOrg = allOrgs.map(item => ({
                    "Tên tổ chức": item.Name,
                    "Số điện thoại": item.Phone,
                    "Email": item.Email,
                    "Địa chỉ": item.Address,
                    "Ngày thành lập": item.DateOfEstablishment ? moment(item.DateOfEstablishment).format('DD-MM-YYYY') : '',
                    "Đường dẫn Website": item.Link,
                    "Logo (URL)": item.Logo ? LinkUpload(item.Logo.split(';')[0]) : ''
                }));
                setDataHeaderOrganizations(customHeadingsOrg);
            })
            .catch(error => {
                console.error("Lỗi khi load dữ liệu tổ chức:", error);
            });
    };

    // <<< HOOK MỚI: Lọc danh sách tổ chức phía client
    const filteredOrganizations = useMemo(() => {
        const { Name, Phone, Email } = dataFilterOrganizations;

        if (!Name && !Phone && !Email) {
            return dataOrganizationsAll;
        }

        return dataOrganizationsAll.filter(org => {
            const nameMatch = Name ? org.Name?.toLowerCase().includes(Name.toLowerCase()) : true;
            const phoneMatch = Phone ? org.Phone?.toLowerCase().includes(Phone.toLowerCase()) : true;
            const emailMatch = Email ? org.Email?.toLowerCase().includes(Email.toLowerCase()) : true;
            return nameMatch && phoneMatch && emailMatch;
        });
    }, [dataFilterOrganizations, dataOrganizationsAll]);


    const showModalOrganizations = (record) => {
        if (typeof record === 'number') {
            setStatusOrganizations(false)
            updateFileListFromUrls(setFileList, '')
            formOrganizations.setFieldsValue({
                "ID": 1,
                "Name": "",
                "Logo": "",
                "Address": "",
                "Phone": "",
                "Email": "",
                Link: "",
                DateOfEstablishment: ""
            })
        }
        else {
            setStatusOrganizations(true)
            updateFileListFromUrls(setFileList, record.Logo)
            formOrganizations.setFieldsValue({
                ...record,
                DateOfEstablishment: record.DateOfEstablishment ? moment(record.DateOfEstablishment) : ''
            })
        }
        setOpenModalOrganizations(true)
    }
    const DeleteOrganizations = (record) => {
        if (record.ID !== 0) {
            swal({
                title: "Bạn có muốn xóa tổ chức này?",
                icon: "warning",
                dangerMode: true,
                buttons: true
            })
                .then(willDelete => {
                    if (willDelete) {
                        axiosClient.post(`/Organizations/DeleteOrganizations/${record.ID}`, record.ID, { headers: header }).then(res => {
                            if (res.status === 200) {
                                swal("Xóa thành công", {
                                    icon: 'success'
                                });
                                LoadDataOrganizations(); // Tải lại dữ liệu sau khi xóa
                            }
                        })
                    }
                    else {
                        swal('Hủy thành công', {
                            icon: 'success'
                        })
                    }
                });
        }
    }
    const columnOrganizations = [
        {
            title: <div style={{ fontSize: 13, color: '#fff', textAlign: 'center' }}>ID</div>,
            dataIndex: 'Path',
            width: 80,
            render: (text, record) => (
                <div style={{ textAlign: 'center', fontSize: 11 }}>
                    {record.ID}
                </div>
            ),
        },

        {
            title: <div style={{ fontSize: 13, color: '#fff', textAlign: 'center' }}>Tên tổ chức</div>,
            dataIndex: 'ForMobile',
            width: 150,
            render: (text, record) => (
                <div style={{ fontSize: 13 }}>
                    <b>{record.Name}</b>
                </div>
            ),
        },

        {
            title: <div style={{ fontSize: 13, color: '#fff', textAlign: 'center' }}>Thông tin</div>,
            dataIndex: 'ForMobile',
            width: 200,
            render: (text, record) => (
                <div style={{ fontSize: 13, lineHeight: '1.8' }}>
                    <div>
                        <Tooltip title={record.Phone}>
                            <PhoneOutlined style={{ color: '#33CCFF', marginRight: 6 }} />
                        </Tooltip>
                        <Text>{record.Phone}</Text>
                    </div>
                    <div>
                        <Tooltip title={record.Email}>
                            <MailOutlined style={{ color: '#FF6347', marginRight: 6 }} />
                        </Tooltip>
                        <Text>{record.Email}</Text>
                    </div>
                    <div>
                        <Tooltip title={record.Link}>
                            <a href={record.Link} target="_blank" rel="noopener noreferrer">
                                <GlobalOutlined style={{ color: '#26A69A', marginRight: 6 }} />
                            </a>
                        </Tooltip>
                        <a href={record.Link} target="_blank" rel="noopener noreferrer">
                            <Text>{record.Link}</Text>
                        </a>
                    </div>
                    <div>
                        <Tooltip title="Ngày thành lập">
                            <CalendarOutlined style={{ color: '#FFA500', marginRight: 6 }} />
                        </Tooltip>
                        <Text>
                            {record.DateOfEstablishment
                                ? moment(record.DateOfEstablishment).format('DD-MM-YYYY')
                                : '—'}
                        </Text>
                    </div>
                </div>
            ),
        }

        ,

        {
            title: <div style={{ fontSize: 13, color: '#fff', textAlign: 'center' }}>Địa chỉ</div>,
            dataIndex: 'Active',
            width: 150,
            render: (text, record) => (
                <div style={{ textAlign: 'left', fontSize: 13 }}>
                    <Text>{record.Address}</Text>
                </div>
            ),
        },


        {
            title: <div style={{ fontSize: 13, color: '#fff', textAlign: 'center' }}>Hình ảnh</div>,
            dataIndex: 'Active',
            width: 60, // Có thể chỉnh nhỏ hơn nếu muốn
            render: (text, record) => {
                const arrayImage = String(record.Logo).split(';');
                return (
                    <div style={{ textAlign: "center", fontSize: 13 }}>
                        <Image.PreviewGroup>
                            <Carousel infinite={false} autoplay dots={false}>
                                {arrayImage.filter(i => i !== '').map((r, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            width: 60,
                                            height: 60,
                                            margin: '0 auto',
                                            borderRadius: 6,
                                            overflow: 'hidden',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            backgroundColor: '#f0f0f0',
                                        }}
                                    >
                                        <Image
                                            src={LinkUpload(r)}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                            }}
                                            preview={true}
                                        />
                                    </div>
                                ))}
                            </Carousel>
                        </Image.PreviewGroup>
                    </div>
                );
            },
        },


        {
            title: <div style={{ fontSize: 10, color: '#fff', textAlign: 'center' }}><SettingOutlined /></div>,
            width: 90,
            render: (text, record) => (
                <div style={{ textAlign: "center" }}>
                    <Button.Group>
                        <Button
                            disabled={!dataPermission.includes('UpdateOrganizations')}
                            icon={<FormOutlined style={{ color: "#33CCFF" }} />}
                            onClick={(e) => showModalOrganizations(record, e)}
                        />
                        <Button
                            disabled={!dataPermission.includes('DeleteOrganizations')}
                            icon={<DeleteOutlined style={{ color: "red" }} />}
                            onClick={(e) => DeleteOrganizations(record, e)}
                        />
                    </Button.Group>
                </div>
            ),
        },
    ];
    const onFinishOrganizations = (values) => {
        const api = statusOrganizations ? `/Organizations/UpdateOrganizations` : `/Organizations/AddOrganizations`
        axiosClient.post(api, {
            ...values,
            Logo: values.Logo === '' ? '/Uploads/LDLawyer/1754529914329No-Avatar.jpg' : values.Logo,
        }, { headers: header }).then(res => {
            swal('Thành công', {
                icon: 'success',
                timer: 3000
            })
            LoadDataOrganizations(); // Tải lại dữ liệu
            setOpenModalOrganizations(false)
        })
    }
    const renderOrganizations = () => {
        return (
            <Form
                id="form-Organizations"
                form={formOrganizations}
                onFinish={onFinishOrganizations}
                name="basic"
                labelCol={{
                    span: 6,
                }}
                wrapperCol={{
                    span: 18,
                }}
                initialValues={{
                    remember: true,
                }}
                autoComplete="off"
            >
                <div >
                    <Form.Item hidden name={'ID'} >
                        <Input />
                    </Form.Item>

                    <Form.Item rules={[
                        {
                            required: true,
                            message: "Nhập tên tổ chức",
                        },
                    ]} label='Tên tổ chức' name={'Name'} >
                        <Input />
                    </Form.Item>
                    <Form.Item rules={[
                        {
                            required: true,
                            message: "Nhập số điện thoại",
                            pattern: new RegExp(/^[0-9]+$/),
                        },
                    ]} name={'Phone'} label={'Số điện thọai'}>
                        <Input maxLength={11} />
                    </Form.Item>
                    <Form.Item rules={[
                        {
                            required: true,
                            message: "Nhập email",
                            type: 'email'
                        },
                    ]} label='Email' name={'Email'} >
                        <Input />
                    </Form.Item>
                    <Form.Item rules={[
                        {
                            required: true,
                            message: "Nhập địa chỉ",

                        },
                    ]} label='Địa chỉ' name={'Address'} >
                        <Input />
                    </Form.Item>
                    <Form.Item rules={[
                        {
                            required: true,
                            message: "Chọn ngày thành lập",

                        },
                    ]} label='Ngày thành lập' name={'DateOfEstablishment'} >
                        <DatePicker style={{ width: '100%' }} format={'DD-MM-YYYY'} />
                    </Form.Item>

                    <Form.Item rules={[
                        {
                            required: false,
                            message: "Nhập link",

                        },
                    ]} label='Link' name={'Link'} >
                        <Input />
                    </Form.Item>
                    <Form.Item rules={[
                        {
                            required: false,
                            message: "Logo",
                        },
                    ]} label='Logo' name={'Logo'} >
                        <Upload
                            multiple
                            listType="picture-card"
                            customRequest={uploadImage}
                            beforeUpload={beforeUpload}
                            maxCount={1}
                            fileList={fileList}
                            onPreview={(file) => window.open(file.url)}
                            onChange={(info) => changeUpload(formOrganizations, 'Logo', info, setFileList)}
                            onRemove={(file) => {
                                const updatedFileList = fileList.filter(f => f.uid !== file.uid);
                                setFileList(updatedFileList);
                            }}
                        >
                            <Button
                                style={{
                                    width: "100%",
                                    height: 100,
                                    border: "2px dashed #40a9ff",
                                    backgroundColor: "#f0faff",
                                    borderRadius: 8,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: 5,
                                    color: "#1890ff",
                                    fontWeight: 500,
                                }}
                            >
                                <PlusOutlined style={{ fontSize: 24 }} />
                                <span>Upload Ảnh</span>
                            </Button>
                        </Upload>
                    </Form.Item>

                </div>

            </Form >
        )
    }
    useEffect(() => {
        formFilterOrganizations.setFieldsValue(dataFilterOrganizations)
        LoadDataOrganizations() // <<< Cập nhật
        LoadDataPermission()
        LoadDataMembers(dataFilterMember)
    }, []);

    // Xuất Excell
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const exportToCSV = (csvData, fileName) => {
        if (!csvData || csvData.length === 0) {
            swal('Không có dữ liệu nên không thể xuất Excel', {
                icon: 'error',
                button: false,
                timer: 2000
            });
            return;
        }

        const ws = XLSX.utils.json_to_sheet(csvData);
        const wscols = Object.keys(csvData[0]).map(() => ({ wch: 25 }));

        ws['!cols'] = wscols;
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });

        saveAs(data, fileName + fileExtension);
    }


    const imageFolderRef = useRef(null)
    const excelFileRef = useRef(null)
    const excelFileRefData = useRef(null);

    const handleMenuClickUploadExcel = () => {
        if (excelFileRef.current) excelFileRef.current.click();
    };
    const handleExcelFile = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        excelFileRefData.current = file;
        setTimeout(() => {
            imageFolderRef.current?.click();
        }, 500);
    };

    const handleImageFolder = async (e) => {
        const imageFiles = [...e.target.files];
        const excelFile = excelFileRefData.current;

        if (!excelFile) {
            swal("Chưa chọn file Excel!", { icon: "error" });
            return;
        }

        await handleFileUploadExcelWithImages(excelFile, imageFiles);

        if (excelFileRef.current) excelFileRef.current.value = null;
        if (imageFolderRef.current) imageFolderRef.current.value = null;
        excelFileRefData.current = null;
    };
    const handleFileUploadExcelWithImages = async (file, imageFiles) => {
        const reader = new FileReader();

        reader.onload = async (e) => {
            const binaryStr = e.target.result;
            const workbook = XLSX.read(binaryStr, { type: "binary" });

            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "", header: 1 });

            const headers = jsonData[0];
            const rawData = jsonData.slice(1);

            const membersRaw = rawData.map(row => {
                const obj = {};
                headers.forEach((key, i) => {
                    obj[key] = row[i];
                });
                return obj;
            });

            const membersToAdd = [];
            const missingImages = [];

            for (const r of membersRaw) {
                const fullName = (r["Tên luật sư"] || "").trim();
                const code = (r["Mã thẻ"] || "").trim();

                if (!fullName) {
                    console.log("⛔ Bỏ qua dòng thiếu tên luật sư.");
                    continue;
                }

                const isDuplicate = dataMembersAll.some(i =>
                    (i.Code || "").trim() === code
                );

                if (isDuplicate) {
                    console.warn(`⚠️ Trùng mã thẻ - bỏ qua: ${fullName} | Mã: ${code}`);
                    continue;
                }

                let imagePath = "";
                const imageFileName = r["Hình ảnh"]?.trim();

                if (imageFileName) {
                    const matchedFile = imageFiles.find(f => f.name === imageFileName);
                    if (matchedFile) {
                        const fmData = new FormData();
                        fmData.append("image", matchedFile);

                        try {
                            const res = await axiosClient.post("/uploadfile", fmData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                    Authorization: `Bearer ${token}`,
                                },
                            });
                            imagePath = res.data?.FilePath || "";
                        } catch (err) {
                            console.error(`🚫 Lỗi upload ảnh [${imageFileName}]:`, err);
                        }
                    } else {
                        console.warn(`❓ Không tìm thấy ảnh: ${imageFileName}`);
                        missingImages.push(`${fullName} (${imageFileName})`);
                    }
                }

                let birthDate = null;
                if (moment(r["Ngày sinh"], "DD-MM-YYYY", true).isValid()) {
                    birthDate = moment(r["Ngày sinh"], "DD-MM-YYYY")
                        .add(1, 'days')
                        .toISOString();
                }

                let joinDate = null;
                if (moment(r["Thời gian tham gia"], "DD-MM-YYYY", true).isValid()) {
                    joinDate = moment(r["Thời gian tham gia"], "DD-MM-YYYY")
                        .add(1, 'days')
                        .toISOString();
                }

                membersToAdd.push({
                    ID: 1,
                    FullName: fullName,
                    BirthDay: birthDate,
                    Address: r["Địa chỉ"] || '',
                    Phone: r["Số điện thoại"] || '',
                    Email: r["Email"] || '',
                    Code: code,
                    JoinDate: joinDate,
                    Organization: r["Tổ chức"] || '',
                    Image: imagePath,
                    Link: r["Đường dẫn"] || '',
                    Introduction: r["Giới thiệu"] || '',
                });
            }

            let successCount = 0;
            for (const m of membersToAdd) {
                try {
                    await axiosClient.post('/Members/AddMembers', m, { headers: header });
                    successCount++;
                } catch (error) {
                    console.error(`❌ Lỗi thêm ${m.FullName}:`, error.response?.data || error.message);
                }
            }

            LoadDataMembers(dataFilterMember);

            swal(`✅ Đã thêm ${successCount} thành viên mới`, {
                icon: 'success',
                timer: 3000,
            });

            if (missingImages.length > 0) {
                swal(`⚠️ Không tìm thấy ảnh cho:\n${missingImages.join("\n")}`, {
                    icon: 'warning',
                    timer: 5000,
                });
            }

            if (fileInputRef.current) {
                fileInputRef.current.value = null;
            }
        };

        reader.readAsBinaryString(file);
    };
    const handleImageFolderOrganizations = async (e) => {
        const imageFiles = [...e.target.files];
        const excelFile = excelFileRefData.current;

        if (!excelFile) {
            swal("Chưa chọn file Excel!", { icon: "error" });
            return;
        }

        await handleFileUploadExcelWithImagesOrganizations(excelFile, imageFiles);

        if (excelFileRef.current) excelFileRef.current.value = null;
        if (imageFolderRef.current) imageFolderRef.current.value = null;
        excelFileRefData.current = null;
    };
    const handleFileUploadExcelWithImagesOrganizations = async (file, imageFiles) => {
        const reader = new FileReader();

        reader.onload = async (e) => {
            const binaryStr = e.target.result;
            const workbook = XLSX.read(binaryStr, { type: "binary" });

            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "", header: 1 });

            const headers = jsonData[0];
            const rawData = jsonData.slice(1);

            const orgsRaw = rawData.map(row => {
                const obj = {};
                headers.forEach((key, i) => {
                    obj[key] = row[i];
                });
                return obj;
            });

            const orgsToAdd = [];
            const missingImages = [];

            for (const r of orgsRaw) {
                const name = (r["Tên tổ chức"] || "").trim();
                if (!name) {
                    console.log("❌ Bỏ qua dòng thiếu tên tổ chức.");
                    continue;
                }

                const isDuplicate = dataOrganizationsAll.some(i =>
                    (i.Name || "").trim() === name
                );
                if (isDuplicate) {
                    console.warn(`⚠️ Trùng tổ chức - bỏ qua: ${name}`);
                    continue;
                }

                let imagePath = "";
                const imageFileName = r["Hình ảnh"]?.trim();

                if (imageFileName) {
                    const matchedFile = imageFiles.find(f => f.name === imageFileName);
                    if (matchedFile) {
                        const fmData = new FormData();
                        fmData.append("image", matchedFile);

                        try {
                            const res = await axiosClient.post("/uploadfile", fmData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                    Authorization: `Bearer ${token}`,
                                },
                            });
                            imagePath = res.data?.FilePath || "";
                        } catch (err) {
                            console.error(`🚫 Lỗi upload ảnh [${imageFileName}]:`, err);
                        }
                    } else {
                        console.warn(`❓ Không tìm thấy ảnh: ${imageFileName}`);
                        missingImages.push(`${name} (${imageFileName})`);
                    }
                }

                let dateOfEstablishment = null;
                if (moment(r["Ngày thành lập"], "DD-MM-YYYY", true).isValid()) {
                    dateOfEstablishment = moment(r["Ngày thành lập"], "DD-MM-YYYY")

                        .toISOString();
                }

                orgsToAdd.push({
                    ID: 1,
                    Name: name,
                    DateOfEstablishment: dateOfEstablishment,
                    Address: r["Địa chỉ"] || "",
                    Phone: r["Số điện thoại"] || "",
                    Email: r["Email"] || "",
                    Image: imagePath,
                    Link: r["Đường dẫn"] || "",
                    Introduction: r["Giới thiệu"] || "",
                });
            }

            let successCount = 0;
            for (const org of orgsToAdd) {
                try {
                    await axiosClient.post('/Organizations/AddOrganizations', org, { headers: header });
                    successCount++;
                } catch (error) {
                    console.error(`❌ Lỗi thêm ${org.Name}:`, error.response?.data || error.message);
                }
            }

            LoadDataOrganizations();

            swal(`✅ Đã thêm ${successCount} tổ chức mới`, {
                icon: 'success',
                timer: 3000,
            });

            if (missingImages.length > 0) {
                swal(`⚠️ Không tìm thấy ảnh cho:\n${missingImages.join("\n")}`, {
                    icon: 'warning',
                    timer: 5000,
                });
            }

            if (fileInputRef.current) {
                fileInputRef.current.value = null;
            }
        };

        reader.readAsBinaryString(file);
    };

    const showModalMembers = (record) => {
        setFileList([])
        formMembers.resetFields();
        if (typeof record === 'number') {
            formMembers.setFieldsValue({

                "ID": 1,
                "FullName": "",
                "BirthDay": "",
                "Address": "",
                "Phone": "",
                "Email": "",
                "Code": "",
                "JoinDate": "",
                "Organization": "",
                "Image": "",
                "Link": "",
                "Introduction": "",
                Interm: 2
            })
            setStatusMembers(false)
            setOpenModalMembers(true)
        }
        else {
            setStatusMembers(true)
            updateFileListFromUrls(setFileList, record.Image)
            formMembers.setFieldsValue({

                "ID": record.ID,
                "FullName": record.FullName,
                "BirthDay": moment(record.BirthDay),
                "Address": record.Address,
                "Phone": record.Phone,
                "Email": record.Email,
                "Code": record.Code,
                "JoinDate": moment(record.JoinDate),
                "Organization": record.Organization,
                "Image": record.Image,
                "Link": record.Link,
                "Introduction": record.Introduction,
                Interm: record.Interm
            })
            setOpenModalMembers(true)
        }
    }


    const onFinishMembers = (values) => {

        if (statusMembers === false) {
            axiosClient.post('/Members/AddMembers', {
                ...values,
                Image: values.Image === '' ? '/Uploads/LDLawyer/1754529914329No-Avatar.jpg' : values.Image,
                BirthDay: moment(values.BirthDay).add(1, 'days'),
                JoinDate: moment(values.JoinDate).add(1, 'days'),
            }, { headers: header }).then(res => {
                swal('Thành công!', {
                    icon: 'success',
                    timer: 3000
                });
                LoadDataMembers(dataFilterMember);
                formMembers.resetFields();
                setOpenModalMembers(false)
            })
        }
        else {
            axiosClient.post('/Members/UpdateMembers', {
                ...values,
                Image: values.Image === '' ? '/Uploads/LDLawyer/1754529914329No-Avatar.jpg' : values.Image,
                BirthDay: moment(values.BirthDay).add(1, 'days'),
                JoinDate: moment(values.JoinDate).add(1, 'days'),
            }, { headers: header }).then(res => {

                swal('Thành công!', {
                    icon: 'success',
                    timer: 3000
                });

                LoadDataMembers(dataFilterMember);
                formMembers.resetFields();
                setOpenModalMembers(false)
            })
        }
    }


    const columnMembers = [
        {
            title: <div style={{ textAlign: "center" }}>ID</div>,
            dataIndex: "ID",
            width: 60,
            render: (text) => <div style={{ textAlign: "center" }}>{text}</div>,
        },
        {
            title: <div style={{ textAlign: "center" }}>Thành viên</div>,
            dataIndex: "FullName",
            width: 150,
            render: (text) => (
                <div style={{ textAlign: "center" }}>
                    <Tag color="blue" style={{ fontSize: 12 }}>{text}</Tag>
                </div>
            ),
        },
        {
            title: <div style={{ textAlign: "center" }}>Liên hệ</div>,
            dataIndex: "Phone",
            width: 200,
            render: (text, record) => (
                <div style={{ fontSize: 12 }}>
                    <Tooltip title={record.Phone}>
                        <PhoneOutlined style={{ color: '#33CCFF' }} /> <Text>{record.Phone}</Text>
                    </Tooltip>
                    <br />
                    <Tooltip title={record.Email}>
                        <MailOutlined style={{ color: '#FF6347' }} /> <Text>{record.Email}</Text>
                    </Tooltip>
                    {record.Link && (
                        <>
                            <br />
                            <Tooltip title="Mở liên kết">
                                <a href={record.Link} target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff' }}>
                                    🔗 Link
                                </a>
                            </Tooltip>
                        </>
                    )}
                    <br />
                    <Text type="secondary">{record.Address}</Text>
                </div>
            ),
        },
        {
            title: <div style={{ textAlign: "center" }}>Thông tin</div>,
            dataIndex: "Code",
            width: 220,
            render: (text, record) => (
                <div style={{ fontSize: 12 }}>
                    <Text strong>Mã:</Text> {record.Code}
                    <br />
                    <Text strong>Tổ chức:</Text> {record.Organization}
                    <br />
                    <Text strong>Ngày sinh:</Text> {moment(record.BirthDay).format("DD-MM-YYYY")}
                    <br />
                    <Text strong>Gia nhập:</Text> {moment(record.JoinDate).format("DD-MM-YYYY")}
                </div>
            ),
        },
        {
            title: <div style={{ textAlign: "center" }}>Giới thiệu</div>,
            dataIndex: "Introduction",
            width: 180,
            render: (text) => (
                <Tooltip title={text}>
                    <div style={{ fontSize: 12 }}>
                        <Text>{limitString(text, 100)}</Text>
                    </div>
                </Tooltip>
            ),
        },
        {
            title: <div style={{ textAlign: "center" }}>Ảnh</div>,
            dataIndex: "Image",
            width: 100,
            render: (text) => {
                const arrayImage = String(text).split(";").filter(i => i !== "");
                return (
                    <div style={{ textAlign: "center" }}>
                        <Image.PreviewGroup>
                            <Carousel infinite={false} autoplay dots={false}>
                                {arrayImage.map((img, idx) => (
                                    <div key={idx} style={{ width: 60, height: 60, margin: "0 auto" }}>
                                        <Image
                                            src={LinkUpload(img)}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                                borderRadius: 4,
                                            }}
                                            preview={true}
                                        />
                                    </div>
                                ))}
                            </Carousel>
                        </Image.PreviewGroup>
                    </div>
                );
            },
        },
        {
            title: <div style={{ textAlign: "center" }}><SettingOutlined /></div>,
            width: 90,
            render: (text, record) => (
                <div style={{ textAlign: "center" }}>
                    <Button.Group>
                        <Button
                            disabled={!dataPermission.includes("UpdateMembers")}
                            icon={<FormOutlined style={{ color: "#33CCFF" }} />}
                            onClick={(e) => showModalMembers(record, e)}
                        />
                        <Button
                            disabled={!dataPermission.includes("DeleteMembers")}
                            icon={<DeleteOutlined style={{ color: "red" }} />}
                            onClick={(e) => DeleteMembers(record, e)}
                        />
                    </Button.Group>
                </div>
            ),
        },
    ];


    const DeleteMembers = (record) => {
        if (record.ID !== 0) {
            swal({
                title: "Bạn có muốn xóa thành viên này?",
                icon: "warning",
                dangerMode: true,
                buttons: true
            })
                .then(willDelete => {
                    if (willDelete) {
                        axiosClient.post(`/Members/DeleteMembers/${record.ID}`, record.ID, { headers: header }).then(res => {
                            if (res.status === 200) {
                                swal("Xóa thành công", {
                                    icon: 'success'
                                });
                                LoadDataMembers(dataFilterMember);
                            }
                        })
                    }
                    else {
                        swal('Hủy thành công', {
                            icon: 'success'
                        })
                    }
                });
        }
    }

    const beforeUpload = (file) => {
        // Tạo file mới với tên mới
        const newFile = new File([file], moment().toDate().valueOf() + `${file.name}`, { type: file.type });
        return newFile;
    };
    const renderMembers = () => {
        return (
            <Form
                id="form-Members"
                form={formMembers}
                onFinish={onFinishMembers}
                name="basic"
                labelCol={{
                    span: 6,
                }}
                wrapperCol={{
                    span: 18,
                }}
                initialValues={{
                    remember: true,
                }}
                autoComplete="off"
            >
                <div >
                    <Form.Item hidden name={'ID'} >
                        <Input />
                    </Form.Item>

                    <Form.Item rules={[
                        {
                            required: true,
                            message: "Nhập tên thành viên",
                        },
                    ]} label='Tên thành viên' name={'FullName'} >
                        <Input />
                    </Form.Item>
                    <Form.Item rules={[
                        {
                            required: true,
                            message: "Nhập số điện thoại",
                            pattern: new RegExp(/^[0-9]+$/),
                        },
                    ]} name={'Phone'} label={'Số điện thọai'}>
                        <Input maxLength={11} />
                    </Form.Item>
                    <Form.Item rules={[
                        {
                            required: true,
                            message: "Nhập email",
                            type: 'email'
                        },
                    ]} label='Email' name={'Email'} >
                        <Input />
                    </Form.Item>
                    <Form.Item label='Địa chỉ' name={'Address'} >
                        <Input />
                    </Form.Item>

                    <Form.Item rules={[
                        {
                            required: true,
                            message: "Ngày sinh",
                        },
                    ]} label='Ngày sinh' name={'BirthDay'} >
                        <DatePicker style={{ width: '100%' }} format={'DD-MM-YYYY'} />
                    </Form.Item>
                    <Form.Item rules={[
                        {
                            required: true,
                            message: "Ngày tham gia",
                        },
                    ]} label='Ngày tham gia' name={'JoinDate'} >
                        <DatePicker style={{ width: '100%' }} format={'DD-MM-YYYY'} />
                    </Form.Item>
                    <Form.Item rules={[
                        {
                            required: false,
                            message: "Nhập tên tổ chức",
                        },
                    ]} label='Thuộc tổ chức' name={'Organization'} >
                        <Input />
                    </Form.Item>
                    <Form.Item rules={[
                        {
                            required: true,
                            message: "Nhập mã thẻ",
                        },
                    ]} label='Mã thẻ' name={'Code'} >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        hidden
                        valuePropName={'checked'}
                        name={'Interm'}
                        label={'Là tập sự'}
                    >
                        <Select>
                            <Option value={1}>Tập sự</Option>
                            <Option value={2}>Chính thức</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item rules={[
                        {
                            required: false,
                            message: "Hình ảnh",
                        },
                    ]} label='Hình ảnh' name={'Image'} >
                        <Upload
                            multiple
                            listType="picture-card"
                            customRequest={uploadImage}
                            beforeUpload={beforeUpload}
                            maxCount={1}
                            fileList={fileList}
                            onPreview={(file) => window.open(file.url)}
                            onChange={(info) => changeUpload(formMembers, 'Image', info, setFileList)}
                            onRemove={(file) => {
                                const updatedFileList = fileList.filter(f => f.uid !== file.uid);
                                setFileList(updatedFileList);
                            }}
                        >
                            <Button
                                style={{
                                    width: "100%",
                                    height: 100,
                                    border: "2px dashed #40a9ff",
                                    backgroundColor: "#f0faff",
                                    borderRadius: 8,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: 5,
                                    color: "#1890ff",
                                    fontWeight: 500,
                                }}
                            >
                                <PlusOutlined style={{ fontSize: 24 }} />
                                <span>Upload Ảnh</span>
                            </Button>
                        </Upload>
                    </Form.Item>
                    <Form.Item rules={[
                        {
                            required: false,
                            message: "Đường dẫn",
                        },
                    ]} label='Link' name={'Link'} >
                        <Input />
                    </Form.Item>
                    <Form.Item rules={[
                        {
                            required: false,
                            message: "Nhập giới thiệu",
                        },
                    ]} label='Giới thiệu' name={'Introduction'} >
                        <Input.TextArea />
                    </Form.Item>
                </div>

            </Form >
        )
    }
    const onFinishFilterCustomer = (values) => {
        const dataSearch = {
            "FullName": values.FullName || "",
            "Phone": values.Phone || "",
            "Email": values.Email || "",
            "Code": values.Code || "",
            "Organization": values.Organization || "",
            "FromDate_JoinDate": values.FromDate_JoinDate || "",
            "ToDate_JoinDate": values.ToDate_JoinDate || ""
        }
        setDataFilterMember(dataSearch);
        LoadDataMembers(dataSearch)
    }
    // <<< HÀM ĐƯỢC CẬP NHẬT
    const onFinishFilterOrganizations = (values) => {
        const dataSearch = {
            "Name": values.Name || "",
            "Phone": values.Phone || "",
            "Email": values.Email || ""
        }
        setDataFilterOrganizations(dataSearch);
    }

    const handleResetFilterOrganizations = () => {
        formFilterOrganizations.resetFields();
        setDataFilterOrganizations({
            "Name": "",
            "Phone": "",
            "Email": "",
        })
    }
    const handleDownloadExcel = () => {
        const fileUrl = `${process.env.PUBLIC_URL}/Excel-Add-Members.xlsx`; // Đường dẫn đến file trong thư mục public
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "Excel-Add-Members.xlsx"; // Tên file khi tải về
        link.click();
    };
    const handleDownloadExcelOrganizations = () => {
        const fileUrl = `${process.env.PUBLIC_URL}/Excel-Add-Organizations.xlsx`; // Đường dẫn đến file trong thư mục public
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "Excel-Add-Organizations.xlsx"; // Tên file khi tải về
        link.click();
    };

    const menuAdd = () => {
        return (
            <div>
                <Menu>
                    <Menu.Item onClick={() => showModalMembers(0)} key="1">Thêm mới</Menu.Item>
                    <Menu.Item onClick={handleMenuClickUploadExcel} key="2">Thêm bằng Excel</Menu.Item>
                    <Menu.Item onClick={handleDownloadExcel} key="3">Mẫu Excel</Menu.Item>
                </Menu>

                {/* File Excel */}
                <input
                    type="file"
                    accept=".xlsx"
                    ref={excelFileRef}
                    style={{ display: "none" }}
                    onChange={handleExcelFile}
                />

                {/* Folder ảnh */}
                <input
                    type="file"
                    ref={imageFolderRef}
                    webkitdirectory="true"
                    directory=""
                    multiple
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleImageFolder}
                />
            </div>
        )

    }
    const menuAddOrganization = () => {
        return (
            <div>
                <Menu>
                    <Menu.Item onClick={() => showModalOrganizations(0)} key="1">Thêm mới</Menu.Item>
                    <Menu.Item onClick={handleMenuClickUploadExcel} key="2">Thêm bằng Excel</Menu.Item>
                    <Menu.Item onClick={handleDownloadExcelOrganizations} key="3">Mẫu Excel</Menu.Item>
                </Menu>

                {/* File Excel */}
                <input
                    type="file"
                    accept=".xlsx"
                    ref={excelFileRef}
                    style={{ display: "none" }}
                    onChange={handleExcelFile}
                />

                {/* Folder ảnh */}
                <input
                    type="file"
                    ref={imageFolderRef}
                    webkitdirectory="true"
                    directory=""
                    multiple
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleImageFolderOrganizations}
                />
            </div>
        )

    }
    const handleDeleteAll = async (e) => {
        try {
            await Promise.all(
                dataMembersAll.map(r =>
                    axiosClient.post(`/Members/DeleteMembers/${r.ID}`, {}, { headers: header })
                )
            );

            LoadDataMembers(dataFilterMember);

        } catch (error) {
            console.error("Lỗi xoá thành viên:", error);
        }
    };
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 12;
    const itemsPerPageOrganzation = 12
    const [searchTerm, setSearchTerm] = useState("");
    const filteredMembers = useMemo(() => {
        if (!searchTerm.trim()) {
            return dataMembersAll;
        }

        const lowercasedFilter = searchTerm.toLowerCase().trim();

        return dataMembersAll.filter(member => {
            const nameMatch = member.FullName?.toLowerCase().includes(lowercasedFilter);
            const codeMatch = member.Code?.toLowerCase().includes(lowercasedFilter);
            return nameMatch || codeMatch;
        });
    }, [searchTerm, dataMembersAll]);
    const handleSearchSubmit = (event) => {
        event.preventDefault();
        setCurrentPage(1);
    };

    const [searchTermOrganzation, setSearchTermOrganzation] = useState("");
    const filteredMembersOrganzation = useMemo(() => {
        if (!searchTermOrganzation.trim()) {
            return dataOrganizationsAll;
        }
        const lowercasedFilter = searchTermOrganzation.toLowerCase().trim();
        return dataOrganizationsAll.filter(member => {
            const nameMatch = member.Name?.toLowerCase().includes(lowercasedFilter);
            const addressMatch = member.Address?.toLowerCase().includes(lowercasedFilter);
            const phoneMatch = member.Phone?.toLowerCase().includes(lowercasedFilter);
            return nameMatch || addressMatch || phoneMatch;
        });
    }, [searchTermOrganzation, dataOrganizationsAll]);

    const handleSearchSubmitOrganzation = (event) => {
        event.preventDefault();
        setCurrentPage(1);
    };

    return (
        <div>
            <Card size="small">
                <Tabs type="card"
                    tabBarGutter={10}
                    tabPosition="top"
                    tabBarStyle={{ backgroundColor: "#D6E4FF", borderRadius: "8px", boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)" }}
                    moreIcon={null} >
                    <TabPane key={1} tab='Quản lý thành viên'>
                        <Row>
                            <Col span={24}>
                                <div>
                                    <form onSubmit={handleSearchSubmit}>
                                        <Input
                                            type="text"
                                            placeholder="Tìm luật sư theo tên hoặc số thẻ..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />

                                    </form>
                                </div>
                            </Col>
                            <Col span={24}>
                                <br />
                            </Col>
                            <Col xl={24} xs={24} span={12}>
                                <Space wrap size={[8, 8]}>
                                    <Dropdown
                                        overlayStyle={{ width: 200 }}
                                        overlay={menuAdd()}
                                        trigger={["click"]}
                                        placement="bottomRight"
                                    >
                                        <Button htmlType="submit" type="primary" style={{ width: "100%", backgroundColor: "#26A69A" }}>
                                            <p>Thêm</p>
                                        </Button>
                                    </Dropdown>


                                    <Button style={{ backgroundColor: '#26A69A', color: 'white' }} onClick={(e) => exportToCSV(dataHeader, `DuLieuThanhVien-${moment().format("DD/MM/YYYY HH:mm")}`)} icon={<FileExcelOutlined />}>Xuất excel</Button>

                                    {/* <Button onClick={(e) => handleDeleteAll(e)} type="primary" style={{ width: "100%", backgroundColor: "red" }}>
                                        <p>Xóa tất cả</p>
                                    </Button> */}
                                </Space>

                            </Col>
                            <Divider />
                            <Col style={{ minHeight: 300 }} span={24}>
                                <Table
                                    rowClassName={(record, index) => index % 2 === 0 ? "gray-color" : ""}
                                    pagination={{ pageSize: itemsPerPage }}
                                    scroll={{ x: 1100 }}
                                    columns={columnMembers}
                                    dataSource={filteredMembers.sort((a, b) => a.ID - b.ID)}
                                    sticky
                                />
                            </Col>
                        </Row>
                    </TabPane>

                    <TabPane key={2} tab='Quản lý tổ chức'>
                        <Row>
                            <Col span={24}>
                                <div>
                                    <form onSubmit={handleSearchSubmitOrganzation}>
                                        <Input
                                            type="text"
                                            placeholder="Tìm tổ chức theo tên..."
                                            value={searchTermOrganzation}
                                            onChange={(e) => setSearchTermOrganzation(e.target.value)}
                                        />

                                    </form>
                                </div>
                            </Col>
                            <Col span={24}>
                                <br />
                            </Col>
                            <Col span={24}>

                                <Space wrap size={[8, 8]}>

                                    <Dropdown
                                        overlayStyle={{ width: 200 }}
                                        overlay={menuAddOrganization()}
                                        trigger={["click"]}
                                        placement="bottomRight"
                                    >
                                        <Button htmlType="submit" type="primary" style={{ width: "100%", backgroundColor: "#26A69A" }}>
                                            <p>Thêm</p>
                                        </Button>
                                    </Dropdown>
                                    <Button
                                        style={{ backgroundColor: '#26A69A', color: 'white' }}
                                        onClick={() => exportToCSV(dataHeaderOrganizations, `DuLieuToChuc-${moment().format("DD-MM-YYYY HH-mm")}`)}
                                        icon={<FileExcelOutlined />}
                                    >
                                        Xuất excel
                                    </Button>
                                </Space>
                            </Col>


                            <Divider />
                            <Col style={{ minHeight: 300 }} span={24}>
                                <Table
                                    rowClassName={(record, index) => (index % 2 === 0 ? 'gray-color' : '')}
                                    pagination={{ pageSize: itemsPerPageOrganzation }}
                                    scroll={{ x: 1100 }}
                                    columns={columnOrganizations}
                                    dataSource={
                                        filteredMembersOrganzation?.sort((a, b) => new Date(a.DateOfEstablishment) - new Date(b.DateOfEstablishment)) || []
                                    }
                                    sticky
                                />
                            </Col>
                        </Row>
                    </TabPane>
                </Tabs >
            </Card>
            <Modal
                width={800}
                onOk={handleOkMembers}
                onCancel={handleCancelMembers}
                open={openModalMembers}
                title={
                    <span>
                        {statusMembers === false ? 'Thêm mới thành viên' : 'Cập nhật thành viên'}
                    </span>
                }
                footer={[
                    <Button onClick={handleCancelMembers} key="back" >
                        Hủy
                    </Button>,
                    <Button form="form-Members" type="primary" htmlType="submit" >
                        Lưu
                    </Button>,
                ]}
            >
                <>{renderMembers()}</>
            </Modal>
            <Modal
                width={800}
                onOk={(e) => setOpenModalOrganizations(false)}
                onCancel={(e) => setOpenModalOrganizations(false)}
                open={openModalOrganizations}
                title={
                    <span>
                        {statusOrganizations === false ? 'Thêm mới tổ chức' : 'Cập nhật tổ chức'}
                    </span>
                }
                footer={[
                    <Button onClick={(e) => setOpenModalOrganizations(false)} key="back" >
                        Hủy
                    </Button>,
                    <Button form="form-Organizations" type="primary" htmlType="submit" >
                        Lưu
                    </Button>,
                ]}
            >
                <>{renderOrganizations()}</>
            </Modal>
        </div >
    )

}
export default Members;